export default __webpack_public_path__ + "static/media/rajan.b8c5a6c6.jpg";